import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import Actions_Wind from '~/Actions_Wind';
import { Dialog } from '@material-ui/core';
import PageTitle from '~/components/PageTitle';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_Btn, EAA_ErrorText, EAA_Upload } from '~/components/EditAndAddItem';
import { leftColor, rightColor } from '~/components/EditAndAddItem/common';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';

const modeInfo = {
  add: {
    title: '上傳產發署每週產業關聯執行方案查核報告表_新增',
  },
  edit: {
    title: '上傳產發署每週產業關聯執行方案查核報告表_編輯',
  },
  view: {
    title: '上傳產發署每週產業關聯執行方案查核報告表_檢視',
  },
};
const titleWidth = 150;
const errorLeft = titleWidth + 20;

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }

  componentDidMount () {
    const { id, getIAMeetReportIdDetail, mode = '' } = this.props;
    if (mode !== 'add')getIAMeetReportIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { IAMeetReportIdDetail: preIAMeetReportIdDetail = {} } = preProps;
    const { IAMeetReportIdDetail = {}, mode } = this.props;
    if (Object.keys(preIAMeetReportIdDetail).length === 0 && Object.keys(IAMeetReportIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: IAMeetReportIdDetail, old_data: IAMeetReportIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('IAMeetReportIdDetail');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data = {} } = this.state;
    const body = {
      check_report_date: data.check_report_date,
      publication_date: data.publication_date,
      doc_num: data.doc_num,
      doc_subject: data.doc_subject,
      doc_upload_files: data.doc_upload_files || [],

      windcontract_id: Actions_Wind.wind_id(),
      admin_status: '0',
      form_status: '0',
    };
    return body;
  }

  add=() => {
    this.setState({ canSend: false });
    const body = this.getSendBody();
    this.props.postAddNewIAMeetReport(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    const { id, putIAMeetReportIdDetail } = this.props;
    this.setState({ canSend: false });
    const body = this.getSendBody();
    putIAMeetReportIdDetail(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.check_report_date) === '',
      returnInputValue(data.publication_date) === '',
      returnInputValue(data.doc_num) === '',
      returnInputValue(data.doc_subject) === '',
      (data.doc_upload_files || []).length === 0,
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  renderDialog=() => {
    const { mode = '' } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const isEdit = mode === 'edit';
    const disabled = mode === 'view' || isCheck;
    // const { status = '0' } = data;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    return (
      <div style={{ width: 768, maxHeight: '80%', backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column', padding: 20, overflowY: 'auto' }}>
        <PageTitle text={modeInfo[mode].title} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='查核報告表產出日期' haveChange={checkChange('check_report_date')} />
              <EAA_Date disabled={disabled} displayBorder value={getTime.returnDate(data.check_report_date)} onChange={data => this.changeData({ label: 'check_report_date', data: getTime.getType3Time(data) })} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='發文日期' haveChange={checkChange('publication_date')} />
              <EAA_Date disabled={disabled} displayBorder value={getTime.returnDate(data.publication_date)} onChange={data => this.changeData({ label: 'publication_date', data: getTime.getType3Time(data) })} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='文號' haveChange={checkChange('doc_num')} />
              <EAA_Input disabled={disabled} displayBorder value={returnInputValue(data.doc_num)} onChange={data => this.changeData({ label: 'doc_num', data })} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='公文主旨' haveChange={checkChange('doc_subject')} />
              <EAA_Memo disabled={disabled} displayBorder value={returnInputValue(data.doc_subject)} onChange={data => this.changeData({ label: 'doc_subject', data })} />
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='上傳檔案' />
              <EAA_Upload disabled={disabled} displayBorder value={data.doc_upload_files || []} onChange={data => this.changeData({ label: 'doc_upload_files', data })} />
            </EAA_ItemContainer>
            {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
          </EAA_Item>
        </EAA_Row>

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>
        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewIAMeetReport' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutIAMeetReportIdDetail' />
      </div>
    );
  }

  render () {
    return (
      <Dialog
        PaperComponent={this.renderDialog}
        open={true}
      />
    );
  }
}

const mapStateToProps = state => ({
  IAMeetReportIdDetail: state.data.IAMeetReportIdDetail,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions_Wind.clearKey(dispatch, { key }),
  getIAMeetReportIdDetail: id => Actions_Wind.getIAMeetReportIdDetail(dispatch, { id }),
  postAddNewIAMeetReport: body => Actions_Wind.postAddNewIAMeetReport(dispatch, { body }),
  putIAMeetReportIdDetail: (id, body) => Actions_Wind.putIAMeetReportIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
